<template>

    <v-overlay :value="model" :opacity="opacity">

        <v-progress-circular
            indeterminate
            size="64"
            :color="color"
            :width="loaderWidth"
        ></v-progress-circular>

        <div :class="textStyles">
            LOADING...
        </div>
    </v-overlay>

</template>

<script>
export default {

    name: 'OverlayLoader',

    props: {
        opacity: {
            type: Number,
            required: false,
            default: 0
        },
        color: {
            type: String,
            required: false,
            default: 'grey',
        },
        loaderWidth: {
            type: Number,
            required: false,
            default: 6
        }
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        textStyles() {
            return 'mt-4 ' + this.color + '--text';
        }
    }
}
</script>
